exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-pagination {\n  margin-top: 20px;\n  text-align: right;\n}\n.content {\n  margin-top: 20px;\n  background: #f2f2f2;\n  padding: 20px;\n}\n.content .el-checkbox__label {\n    display: inline;\n}\n", ""]);

// exports
